import React from 'react';
import clsx from 'clsx';
import { useCard } from './CardContext.js';
const Simple = ({ title }) => {
    return React.createElement("h3", { className: "text-basicSurface-900" }, title);
};
const WithDescription = ({ title, description }) => {
    return (React.createElement("div", null,
        React.createElement("h3", { className: "text-basicSurface-900" }, title),
        React.createElement("p", { className: "mt-1 text-basicSurface-500" }, description)));
};
const WithAction = ({ title, action }) => {
    return (React.createElement("div", { className: "-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap" },
        React.createElement("div", { className: "ml-4 mt-2" },
            React.createElement("h3", { className: "text-basicSurface-900" }, title)),
        React.createElement("div", { className: "ml-4 mt-2 flex-shrink-0" }, action)));
};
const WithDescriptionAndAction = ({ title, description, action }) => {
    return (React.createElement("div", { className: "-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap" },
        React.createElement("div", { className: "ml-4 mt-4" },
            React.createElement("h3", { className: "leading-6 text-basicSurface-900" }, title),
            React.createElement("p", { className: "mt-1 text-basicSurface-500" }, description)),
        React.createElement("div", { className: "ml-4 mt-4 flex-shrink-0" }, action)));
};
export const CardHeader = props => {
    const { title, description, action, withBorder = false, children } = props;
    const { padding } = useCard();
    let content;
    if (!!title && !!description && !!action) {
        content = (React.createElement(WithDescriptionAndAction, { title: title, description: description, action: action }));
    }
    else if (action) {
        content = React.createElement(WithAction, { title: title, action: action });
    }
    else if (description) {
        content = React.createElement(WithDescription, { title: title, description: description });
    }
    else if (title) {
        content = React.createElement(Simple, { title: title });
    }
    else {
        content = children;
    }
    return (React.createElement("div", { className: clsx(padding === 'md' && 'px-4 py-5 sm:p-6 ', padding === 'sm' && 'px-4 py-5 sm:px-3', !withBorder && 'pb-0 sm:pb-0', withBorder && 'border-b border-surface-200/50') }, content));
};
//# sourceMappingURL=CardHeader.js.map